import { isEqual, pick } from 'lodash';
import { RsvpQuestion } from '@bridebook/web/lib/rsvp/types';

export const isSameRsvpQuestion = (a: RsvpQuestion, b: RsvpQuestion): boolean => {
  const questionA = pick(a, ['question', 'type', ...(a.type === 'list' ? ['options'] : [])]);

  return isEqual(questionA, b);
};
